import { IInstagramService } from 'application/services/instagram';
import { IInstagramStore } from './IInstagramStore';
import { makeAutoObservable } from 'mobx';
import { InstagramPost } from 'domains/instagramPost';
import { MediaUpdateDTO } from 'infrastructure/dtos/instagramPost';

export class InstagramStore implements IInstagramStore {
  private _instagramPosts: InstagramPost[] | undefined = undefined;
  private _isApproving: boolean = false;
  private _isRejecting: boolean = false;

  constructor(private readonly service: IInstagramService) {
    makeAutoObservable(this);
  }

  set instagramPosts(value: InstagramPost[] | undefined) {
    this._instagramPosts = value;
  }

  get instagramPosts(): InstagramPost[] | undefined {
    return this._instagramPosts;
  }

  set isApproving(value: boolean) {
    this._isApproving = value;
  }

  get isApproving(): boolean {
    return this._isApproving;
  }

  set isRejecting(value: boolean) {
    this._isRejecting = value;
  }

  get isRejecting(): boolean {
    return this._isRejecting;
  }

  async getInstagramPostsByUserId({ userId }: { userId: string }): Promise<void> {
    this.instagramPosts = await this.service.getInstagramPostsByUserId({ userId });
  }

  async approvePost(body: {
    posts: {
      id: string;
      category_id: string;
      aspect_ratio: number;
    }[];
  }): Promise<void> {
    this.isApproving = true;
    try {
      await this.service.approvePost(body);
      this.instagramPosts = this.instagramPosts?.filter(
        post => post.id.toString() !== body.posts[0].id
      );
    } finally {
      this.isApproving = false;
    }
  }

  async rejectPost(body: {
    posts: {
      id: string;
      reason?: string;
    }[];
  }): Promise<void> {
    this.isRejecting = true;
    try {
      await this.service.rejectPost(body);
      this.instagramPosts = this.instagramPosts?.filter(
        post => post.id.toString() !== body.posts[0].id
      );
    } finally {
      this.isRejecting = false;
    }
  }

  async updateMedia(body: MediaUpdateDTO): Promise<void> {
    await this.service.updateMedia(body);
  }
}
